import { render, staticRenderFns } from "./OtherBusiness.vue?vue&type=template&id=782be851&scoped=true&"
import script from "./OtherBusiness.vue?vue&type=script&lang=js&"
export * from "./OtherBusiness.vue?vue&type=script&lang=js&"
import style0 from "./OtherBusiness.vue?vue&type=style&index=0&id=782be851&lang=scss&scoped=true&"
import style1 from "./OtherBusiness.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782be851",
  null
  
)

export default component.exports